<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('article.title')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-text-field
            v-model="item.namefr"
            :error-messages="namefrErrors"
            :label="$t('article.titlefr')"
            required
            @input="$v.item.namefr.$touch()"
            @blur="$v.item.namefr.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12" >
          <InputDate
            v-model="item.date"
            :label="$t('global.date')"
            :error-messages="dateErrors"
          />
        </v-col>
      </v-row>
      <!--
        
      <v-row>
        <v-col cols="12" sm="12" md="12" v-if="!item['@id']">
          <v-file-input
            v-model="item.image"
            accept="image/*"
            :error-messages="imageErrors"
            :label="$t('global.fileinput')"
            required
            show-size
          ></v-file-input>
        </v-col>
      </v-row>
      -->

      <v-row>
        <v-col cols="12" sm="12" md="12" v-if="!item['@id']">
          <v-file-input
            v-model="item.file"
            :error-messages="fileErrors"
            :label="$t('global.fileinput')"
            
            show-size
          ></v-file-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12" >
          <v-text-field
            v-model="item.link"
            :error-messages="linkErrors"
            :label="$t('article.link')"
            
            @input="$v.item.link.$touch()"
            @blur="$v.item.link.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12" >
          <v-text-field
            v-model="item.linkfr"
            :error-messages="linkfrErrors"
            :label="$t('article.linkfr')"
            
            @input="$v.item.linkfr.$touch()"
            @blur="$v.item.linkfr.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12" >
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('article.enabled') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.enabled"
                :error-messages="enabledErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12" >
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('global.hub') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.public"
                :error-messages="publicErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Loading from '../../components/Loading';
import InputDate from '../InputDate';
import { date } from '../../validators/date';
import { maxsizefile } from '../../utils/files';

export default {
  name: 'ArticleForm',
  mixins: [validationMixin],
  components: {
    Loading,
    InputDate
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {

  },
  data() {
    return {
        file: null,
        name: null,
        namefr: null,
        link: null,
        linkfr: null,
        enabled: null,
        public: null,
        date: null,
    };
  },
  computed: {
    isLoading() {
      return (false
       );
    },
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    namefrErrors() {
      const errors = [];

      if (!this.$v.item.namefr.$dirty) return errors;

      has(this.violations, 'namefr') && errors.push(this.violations.namefr);

      !this.$v.item.namefr.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    linkErrors() {
      const errors = [];

      if (!this.$v.item.link.$dirty) return errors;

      has(this.violations, 'link') && errors.push(this.violations.name);

     // !this.$v.item.link.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    linkfrErrors() {
      const errors = [];

      if (!this.$v.item.linkfr.$dirty) return errors;

      has(this.violations, 'linkfr') && errors.push(this.violations.name);


      //!this.$v.item.linkfr.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    dateErrors() {
      const errors = [];
      if (!this.$v.item.date.$dirty) return errors;
      has(this.violations, 'date') && errors.push(this.violations.date);
      return errors;
    },
    fileErrors() {
      const errors = [];

      if (!this.$v.item.file.$dirty) return errors;

      has(this.violations, 'file') && errors.push(this.violations.file);

      !this.$v.item.file.maxsizefile && errors.push(this.$t('global.maxsize'));
      return errors;
    },
    enabledErrors() {
      const errors = [];
      if (!this.$v.item.enabled.$dirty) return errors;
      has(this.violations, 'enabled') && errors.push(this.violations.enabled);
      return errors;
    },
    publicErrors() {
      const errors = [];
      if (!this.$v.item.public.$dirty) return errors;
      has(this.violations, 'public') && errors.push(this.violations.public);
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {

  },
  validations: {
    item: {
      file: {
       // required,
        maxsizefile : maxsizefile(10),
      },
      name: {
        required,
      },
      namefr: {
        required,
      },
      date: {
        date,
      },
      link: {
   //     required,
      },
      linkfr: {
   //     required,
      },
      enabled: {
      },
      public: {
      },
    }
  }
};
</script>
